define( 'templates/contract-templates',['templates/template-builder'], function(TemplateBuilder) {
    var templateBuilder = new TemplateBuilder();
    
    return {
        /**
         * HEADERS -------------------------------------------------------
         */
        'headers' : {
            // Sortable
            // TODO Set to "name" instead of "nameCI"
            'name' : templateBuilder.sortableHeader('name', 'Quote number', 'nameCI'),
            'timezone' : templateBuilder.sortableHeader('timezone', 'Timezone', 'timezone'),
            'startDate' : templateBuilder.sortableHeader('startDate', 'Start date', 'startTime'),
            'endDate' : templateBuilder.sortableHeader('endDate', 'End date', 'endTime'),
            'state' : templateBuilder.sortableHeader('state', 'State', 'state'),
            
            // Basic 
            'group' : templateBuilder.basicHeader('group', 'Group'),
            'clientName' : templateBuilder.basicHeader('clientName', 'Client'),
            'locked' : templateBuilder.basicHeader('locked', 'Locked'),
            'valid' : templateBuilder.basicHeader('valid', 'Valid'),
            'bidir' : templateBuilder.basicHeader('bidir', 'Bidir'),
            'roaming' : templateBuilder.basicHeader('roaming', 'Roaming'),
            'activationPeriod' : templateBuilder.basicHeader('activationPeriod', 'Activation period'),
            'feegrid' : templateBuilder.basicHeader('feegrid', 'Feegrid'),
            'mode' : templateBuilder.basicHeader('mode', 'Mode'),
            'freeMessages' : templateBuilder.basicHeader('freeMessages', 'Free messages'),
            'maxTokens' : templateBuilder.basicHeader('maxTokens', 'Max tokens'),
            'tokensInUse' : templateBuilder.basicHeader('tokensInUse', 'Tokens in use'),
            'tokensUsed' : templateBuilder.basicHeader('tokensUsed', 'Tokens used'),
            'type' : templateBuilder.basicHeader('type', 'Type'),
            'qdrIncluded' : templateBuilder.basicHeader('qdrIncluded', 'Qdr included')
        },
        
        /**
         * DATA TEMPLATES -------------------------------------------------------
         */
        'templates' : {
            'name' : {
                'nodeType':'td',
                'content': {
                    'classes' : ['contract-info-link'],
                    'data' : {
                        'start-time' : '${startTime}',
                        'end-time' : '${endTime}', 
                        'max-tokens' : '${maxTokens}', 
                        'id' :  '${id}', 
                        'has-next' : '${hasNext}',
                        'is-next' : '${isNext}'
                    },
                    'nodeType':'a',
                    'href': '${url}',
                    'content': '${name}'
                }            
            },
            'timezone' : templateBuilder.basicNode( '${timezone}' ),
            'clientName' : templateBuilder.basicNode( '${clientName}' ),
            'group' : templateBuilder.linkNode( '${groupUrl}' ,'${groupName}' ),
            'startDate' : templateBuilder.basicNode( '${startDate}' ),
            'endDate' : templateBuilder.basicNode( '${endDate}' ),
            'locked' : templateBuilder.booleanNode( '${locked}', ['icon-lock', 'medium'], ['icon-unlock', 'medium']),
            'state' : templateBuilder.basicNode( '${state2Display}'),
            'valid' : templateBuilder.booleanNode( '${valid}'),
            'bidir' : templateBuilder.booleanNode( '${bidir}'),
            'roaming' : templateBuilder.booleanNode( '${roaming}'),
            'activationPeriod' : templateBuilder.basicNode( '${activationPeriodDuration2Display}'),
            'feegrid' : templateBuilder.linkNode( '${feegridUrl}', '${feegridName}'),
            'mode' : templateBuilder.basicNode( '${mode2Display}'),
            'freeMessages' : templateBuilder.basicNode( '${freeMessages}', null, {'align' : 'center'}),
            'maxTokens' : templateBuilder.basicNode( '${maxTokens}', null, {'align' : 'center'}),
            'tokensInUse' : templateBuilder.basicNode( '${tokensInUse}', null, {'align' : 'center'}),
            'tokensUsed' : templateBuilder.basicNode( '${tokensUsed}', null, {'align' : 'center'}),
            'type' : templateBuilder.basicNode( '${type}' ),
            'qdrIncluded' : templateBuilder.booleanNode( '${qdrIncluded}')
        } // end templates data
    }; // end return
});



